import { isObject } from '@pineapplelab/util';
import { FBase } from './FBase';
import { Paging, PagingOrderType } from '@pineapplelab/paging';
import { UserProfile } from './userProfile';


export class User extends FBase {
  name: string;
  lastName: string;
  userName: string;
  gender: string;
  phone: string;
  avatar: string;
  identification: string;
  email: string;
  isArtist: boolean;
  description: string;
  calendar: any;

  __profiles: UserProfile[];
  __fileImage: File;

  constructor(json?: { [key: string]: any }) {
    super();
    if (isObject(json)) {
      this.fromJson(json);
    }
  }
}

export namespace User {
  export const PATH = 'users';

  export const PAGING = new Paging<User>(<Paging.IPaging>{
    collection: PATH,
    orderOptions: [
      { field: 'email', label: 'Email', placeholder: 'Filter by email', dataType: Paging.dataType.string },
      { field: 'name', label: 'First Name', placeholder: 'Filter by first name', dataType: Paging.dataType.string },
      { field: 'last_name', label: 'Last Name', placeholder: 'Filter by last name', dataType: Paging.dataType.string },
      { field: 'created_at', label: 'Created At', placeholder: 'Filter by Created At', dataType: Paging.dataType.timestamp }
    ],
    orderType: PagingOrderType.desc,
    orderBy: 'email',
  });
}
